module.exports = __webpack_public_path__ + "img/ledgers.closed.daily.d0eba1d8.png";